import type { FaireProductEntity } from "../../entity_types/product";

export const p_34lfv0z4: FaireProductEntity = {
  token: "p_34lfv0z4",
  type: "product",
  name: "Hi Baby Sky Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/411de0fd4156dccf559fff36445b2c36ace4ca16cd7a5a50e2893f40812fcf44.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2a4a921827605c2d058cfbefe241074092c672bfd5dd0fb1926b1cdedbb91c9.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:17.128Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
